import { render, staticRenderFns } from "./chat.vue?vue&type=template&id=05e2c4fb&scoped=true&"
import script from "./chat.vue?vue&type=script&lang=js&"
export * from "./chat.vue?vue&type=script&lang=js&"
import style0 from "./chat.vue?vue&type=style&index=0&id=05e2c4fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e2c4fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05e2c4fb')) {
      api.createRecord('05e2c4fb', component.options)
    } else {
      api.reload('05e2c4fb', component.options)
    }
    module.hot.accept("./chat.vue?vue&type=template&id=05e2c4fb&scoped=true&", function () {
      api.rerender('05e2c4fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataChat/chat.vue"
export default component.exports